import { getCookie, get_token } from '@/router/index.js';
import Highcharts from 'highcharts';
export default {
  name: 'TeamDashboard',
  data: () => ({
    current_date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
    burnout_alert: {
      show: true,
      title: '3 Team Members Approaching Burnout Risk',
      message: 'Sarah (92% utilization), Michael (88% utilization), and Zanele (87% utilization) have exceeded optimal workload thresholds for 2 consecutive weeks.',
      action: 'Review Allocations'
    },
    resources: [
      { name: 'Orcaa', percentage: 85, color: '#ff6b35' },
      { name: 'IC Workbook', percentage: 72, color: '#1cc88a' },
      { name: 'Proba Workflows', percentage: 92, color: '#ff4757' },
      { name: 'ComplyOn', percentage: 68, color: '#1cc88a' },
      { name: 'Proba Analytics', percentage: 55, color: '#1cc88a' },
      { name: 'X-Verdict', percentage: 45, color: '#1cc88a' }
    ],
    total_hours: {
      used: 328,
      total: 400
    },
    chart_data: null,

    //Team Members
    team_members: [],
    team_members_loading: false,

    //Team Performance from IC Workbook
    kpis: [],
    kpis_loading: false,
    velocity_data: null,
    recognition: "Fetching latest achievements...",

    //get critical tasks from IC Workbook
    critical_tasks: [],
    tasks_loading: false,
    overdue_count: 0,

    //sprint chart
    velocity_chart: null,
    velocity_loading: false,

    upcoming_deadlines: [],
    deadlines_loading: false,

    //Team courses from Orcaa
    team_training: [],
    upcoming_training: 'Loading session details...',
    training_loading: false,
    csrfToken: ''

  }),
  mounted() {
    this.csrfToken = getCookie('csrftoken');
    this.initialize_chart();
    this.fetch_dashboard_data();

  },
  methods: {

    update_dashboard_data(data) {
      if (data.metrics) this.key_metrics = data.metrics;
      if (data.members) this.team_members = data.members;
      if (data.resources) this.resources = data.resources;
      if (data.tasks) this.critical_tasks = data.tasks;
      if (data.deadlines) this.upcoming_deadlines = data.deadlines;
      if (data.training) this.team_training = data.training;
    },

    initialize_chart() {
      const canvas = this.$refs.chart_canvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const width = canvas.parentElement.clientWidth;
      const height = 200;
      canvas.width = width;
      canvas.height = height;

      const sprints = ['Sprint 19', 'Sprint 20', 'Sprint 21', 'Sprint 22', 'Sprint 23', 'Sprint 24'];
      const completed = [50, 53, 48, 58, 60, 65];
      const planned = [52, 55, 56, 58, 60, 63];

      const padding = 40;
      const chart_width = width - 2 * padding;
      const chart_height = height - 2 * padding;
      const max_value = 70;
      const point_spacing = chart_width / (sprints.length - 1);

      ctx.fillStyle = '#f8f9fc';
      ctx.fillRect(0, 0, width, height);

      ctx.strokeStyle = '#e3e6f0';
      ctx.lineWidth = 1;
      for (let i = 0; i <= 5; i++) {
        const y = padding + (chart_height * i) / 5;
        ctx.beginPath();
        ctx.moveTo(padding, y);
        ctx.lineTo(width - padding, y);
        ctx.stroke();
      }

      const draw_line = (points, color, dashed = false) => {
        ctx.strokeStyle = color;
        ctx.lineWidth = 3;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';

        if (dashed) {
          ctx.setLineDash([5, 5]);
        } else {
          ctx.setLineDash([]);
        }

        ctx.beginPath();
        points.forEach((point, i) => {
          const x = padding + i * point_spacing;
          const y = padding + chart_height - (point / max_value) * chart_height;
          if (i === 0) {
            ctx.moveTo(x, y);
          } else {
            ctx.lineTo(x, y);
          }
        });
        ctx.stroke();

        if (!dashed) {
          points.forEach((point, i) => {
            const x = padding + i * point_spacing;
            const y = padding + chart_height - (point / max_value) * chart_height;
            ctx.fillStyle = color;
            ctx.beginPath();
            ctx.arc(x, y, 5, 0, Math.PI * 2);
            ctx.fill();
            ctx.strokeStyle = '#fff';
            ctx.lineWidth = 2;
            ctx.stroke();
          });
        }
      };

      draw_line(completed, '#4e73df', false);
      draw_line(planned, '#1cc88a', true);

      ctx.fillStyle = '#858796';
      ctx.font = '11px sans-serif';
      ctx.textAlign = 'center';
      sprints.forEach((sprint, i) => {
        const x = padding + i * point_spacing;
        ctx.fillText(sprint, x, height - 10);
      });
    },

    handle_allocations() {
      this.$notyf.info('Opening resource allocation manager...');
    },

    async fetch_dashboard_data() {
      // Fetch team members first
      await this.fetch_team_members();
      await this.fetch_critical_tasks();
      await this.fetch_sprint_velocity();
      await this.fetch_team_performance();
      await this.fetch_upcoming_deadlines();

      // Only proceed if we have team members
      if (this.team_members && this.team_members.length > 0) {
        // Use Promise.all to fetch all data in parallel
        await Promise.all([
          this.fetch_team_training(),
        ]);
      } else {
        console.log('No team members found, skipping dependent API calls');
      }
    },

    async fetch_team_members() {
      this.team_members_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_team_members/`;

      try {
          const res = await fetch(url, {
              method: "GET",
              headers: { "Authorization": `Token ${token}`, "X-CSRFToken": this.csrfToken }
          });
          const json = await res.json();
          if (json.status === "success") {
              this.team_members = json.members.map(member => ({
                  id: member.id,
                  name: member.full_name,
                  initials: member.initials || member.full_name.charAt(0),
                  team: member.team_name,
                  status: member.is_online ? 'online' : 'offline',
                  color: member.avatar_color,
                  capacity: member.capacity_percentage || 0,
                  active: member.active_tasks_count || 0,
                  overdue: member.overdue_tasks_count || 0
              }));
          }
      } catch (err) {
          console.error("ComplyOn Error:", err);
      } finally {
          this.team_members_loading = false;
      }
    },

    async fetch_team_performance() {
      this.kpis_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_team_performance_metrics/`;

      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrfToken
          },
          body: JSON.stringify({})
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const json = await res.json();

        if (json.status === "success" && json.metrics) {
          const m = json.metrics;

          this.kpis = [
            { label: 'Active Tasks', value: m.total_active || 0, color: '#3498db' },
            { label: 'Team Utilization', value: (m.avg_utilization || 0) + '%', color: '#2ecc71' },
            { label: 'Overdue Items', value: m.total_overdue || 0, color: '#f39c12' },
            { label: 'Team Health Score', value: (m.health_score || 0) + '/10', color: '#9b59b6' }
          ];
          this.recognition = m.latest_achievement || "Team is performing within expected parameters.";
        }
      } catch (err) {
        console.error("IC Workbook Error:", err);
      } finally {
        this.kpis_loading = false;
      }
    },

    async fetch_critical_tasks() {
      this.tasks_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_critical_tasks/`;

      try {
          const res = await fetch(url, {
              method: "POST",
              credentials: 'include',
              headers: {
                  "Authorization": `Token ${token}`,
                  "Content-Type": "application/json",
                  "X-CSRFToken": this.csrfToken
              },
              body: JSON.stringify({})
          });

          const json = await res.json();
          // Reset everything before checking data
          this.critical_tasks = [];
          this.overdue_count = 0;

          if (json.status === "success" && json.tasks && json.tasks.length > 0) {
              this.critical_tasks = json.tasks.map(t => ({
                  id: t.id,
                  title: t.task_name,
                  assigned: t.assignee_name,
                  due: t.due_date,
                  status: t.status_label,
                  status_class: this.get_status_badge_class(t.status_label),
                  status_color: t.hex_color || '#ff4757'
              }));

              this.overdue_count = this.critical_tasks.filter(t => t.status === 'Overdue').length;
          }
      } catch (err) {
          console.error("Critical Tasks Error:", err);
          this.critical_tasks = []; // Fallback to empty state
      } finally {
          this.tasks_loading = false;
      }
    },

    get_status_badge_class(status) {
      const map = {
          'Overdue': 'bg-danger',
          'In Progress': 'bg-primary',
          'Pending': 'bg-warning text-dark'
      };
      return Reflect.has(map, status)
          ? Reflect.get(map, status)
          : 'bg-secondary';
    },

    async fetch_sprint_velocity() {
      this.velocity_loading = true;
      this.velocity_data = null;

      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_sprint_velocity/`;

      try {
        const res = await fetch(url, {
          method: "POST",
          credentials: 'include',
          headers: {
            "Authorization": `Token ${token}`,
            "Content-Type": "application/json",
            "X-CSRFToken": this.csrfToken
          },
          body: JSON.stringify({})
        });

        const json = await res.json();

        // In our new backend, json.velocity.tasks contains the list
        if (json.status === "success" && json.velocity && json.velocity.tasks) {
          this.velocity_data = json.velocity.tasks;
        }
      } catch (err) {
        console.error("Task Workload Load Error:", err);
      } finally {
        this.velocity_loading = false;
      }
    },

    render_velocity_chart(data) {
      this.velocity_chart = Highcharts.chart(this.$refs.velocity_chart_container, {
        chart: {
          type: 'areaspline',
          backgroundColor: 'transparent',
          height: 220
        },
        title: { text: null },
        xAxis: {
          categories: data.labels,
          gridLineWidth: 0,
          labels: { style: { color: '#858796' } }
        },
        yAxis: {
          title: { text: 'Story Points' },
          gridLineDashStyle: 'Dash',
          gridLineColor: '#e3e6f0'
        },
        tooltip: {
          shared: true,
          valueSuffix: ' pts'
        },
        credits: { enabled: false },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.1
          }
        },
        series: [{
          name: 'Completed',
          data: data.completed_points,
          color: '#4e73df',
          marker: { symbol: 'circle' }
        }, {
          name: 'Planned',
          data: data.planned_points,
          color: '#1cc88a',
          dashStyle: 'Dash',
          marker: { symbol: 'diamond' }
        }]
      });
    },

    async fetch_upcoming_deadlines() {
      this.deadlines_loading = true;
      const token = get_token();
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_upcoming_deadlines/`;

      try {
          const res = await fetch(url, {
              method: "POST",
              credentials: 'include',
              headers: {
                  "Authorization": `Token ${token}`,
                  "Content-Type": "application/json",
                  "X-CSRFToken": this.csrfToken
              },
              body: JSON.stringify({})
          });

          const json = await res.json();

          if (json.status === "success" && json.deadlines) {
              this.upcoming_deadlines = json.deadlines.map(d => {
                  const date_due = new Date(d.due_date);
                  const today = new Date();

                  // Reset hours for accurate day calculation
                  today.setHours(0, 0, 0, 0);
                  date_due.setHours(0, 0, 0, 0);

                  const diff_time = date_due - today;
                  const diff_days = Math.ceil(diff_time / (1000 * 60 * 60 * 24));

                  return {
                      id: d.id,
                      title: d.task_name,
                      tasks_remaining: d.subtasks_count || 0,
                      // Display the specific date (e.g., "Feb 5")
                      date: date_due.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
                      // Display planning context
                      days_left_text: diff_days === 0 ? 'Due Today' : (diff_days === 1 ? 'Tomorrow' : `${diff_days} days left`),
                      urgency_color: diff_days <= 2 ? '#e74a3b' : '#1cc88a'
                  };
              });

              // Sort deadlines so the closest ones are at the top
              this.upcoming_deadlines.sort((a, b) => new Date(a.date) - new Date(b.date));
          }
      } catch (err) {
          console.error("Failed to fetch deadlines:", err);
          this.upcoming_deadlines = [];
      } finally {
          this.deadlines_loading = false;
      }
    },

    async fetch_team_training() {
        this.training_loading = true;
        const token = get_token();
        const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_team_training_progress/`;
        const user_ids = this.team_members.map(m => m.id);

        try {
            const res = await fetch(url, {
                method: "POST",
                headers: {
                    "Authorization": `Token ${token}`,
                    "Content-Type": "application/json",
                    "X-CSRFToken": this.csrfToken
                },
                body: JSON.stringify({ user_ids: user_ids })
            });

            const json = await res.json();
            if (json.status === "success" && json.training_data) {
                const data = json.training_data;

                // Map the assigned courses and progress
                this.team_training = data.courses.map(c => ({
                    id: c.id,
                    name: c.title,
                    completed: c.completed_count,
                    total: c.total_assigned,
                    status: c.status_text, // e.g., "Pending: Mujammil, Sfiso"
                    gradient: c.is_fully_completed
                        ? 'linear-gradient(90deg, #1cc88a, #13855c)'
                        : 'linear-gradient(90deg, #4e73df, #224abe)'
                }));

                // Requirement: Upcoming training session with date
                this.upcoming_training = data.next_session
                    ? `${data.next_session.title} - ${new Date(data.next_session.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
                    : 'No upcoming workshops scheduled.';
            }
        } catch (err) {
            console.error("Training Sync Error:", err);
        } finally {
            this.training_loading = false;
        }
    },

  }
};
